import { styled } from "@mui/material";

export const ToastStyled = styled("div")`
  display: grid;
  justify-items: center;
  gap: 0.5rem;
`;
